import { observer } from 'mobx-react-lite'
import { FC, useMemo } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useNavigate } from 'react-router-dom'
import { EmptyState } from '../../../features/empty-state'
import { useAuth } from '../../hooks/useAuth'
import { Box } from '../core/Components'
import { Loader } from '../platform/new-explore/components/Table'
import TableRow from '../platform/new-explore/components/TableRow'
import useSelectedMedia from '../platform/new-explore/hooks/useSelectedMedia'
import useSounds, { DEFAULT_FILTERS } from '../platform/new-explore/hooks/useSounds'

const SoundsTable: FC<{ walletAddress: string }> = ({ walletAddress }) => {
  const { currentWalletAddress, user } = useAuth()
  const navigate = useNavigate()
  const { data, hasMore, getNextPage, status } = useSounds({
    ...DEFAULT_FILTERS,
    walletAddress,
    shadowBlocklist: false
  })
  const queueData = useMemo(() => data.map((item) => item.id), [data])
  const { index, type, handleSelect } = useSelectedMedia({ queueData })

  const emptyStateOnClick = () => {
    if (currentWalletAddress === walletAddress) return navigate('/studio')
    return navigate('/home/sounds')
  }

  if (data.length === 0 && status === 'ready') {
    return (
      <EmptyState.Root>
        <EmptyState.Icon />
        <EmptyState.Text>No sounds minted yet!</EmptyState.Text>
        <EmptyState.ButtonRow>
          <EmptyState.PrimaryButton onClick={emptyStateOnClick}>
            {currentWalletAddress === walletAddress ? 'Upload your first sound' : 'Explore sounds'}
          </EmptyState.PrimaryButton>
        </EmptyState.ButtonRow>
      </EmptyState.Root>
    )
  }
  return (
    <Box css={{ display: 'flex', alignItems: 'stretch', minHeight: '100vh' }}>
      <Box css={{ flex: 1, position: 'relative', marginTop: '16px' }}>
        <InfiniteScroll
          dataLength={data.length}
          hasMore={hasMore}
          loader={<Loader />}
          next={getNextPage}
        >
          {data.map((media, i) => (
            <TableRow
              media={media}
              key={media.id}
              onSelect={handleSelect}
              active={media.id === index}
            />
          ))}
        </InfiniteScroll>
      </Box>
    </Box>
  )
}

export default observer(SoundsTable)
